import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/813f61ce-7b5a-4370-a05e-dcec7a6a611a";
export const REGISTER_URL = "https://a.ntrk2.com/b2422e91-aa60-41a6-8e50-5349ad9ad9f1";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://pkpop.kzw2a.com/download?openExternalBrowser=1&id=2cz5ad19rvxfyw4";

export * from "./codes";
export * from "./context";
